import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Header from 'reservations/base/components/Header';
import { WHITE } from 'reservations/brand/constants';

interface LocationListTopMatterProps {
  restaurantName: string;
}

const LocationListTopMatter = ({
  restaurantName
}: LocationListTopMatterProps) => (
  <Grid container direction="column">
    <Grid
      item
      sx={theme => ({
        [theme.breakpoints.down('md')]: {
          marginTop: '40px'
        },
        padding: '10px 20px',
        color: WHITE
      })}
    >
      <Header text={restaurantName} />
    </Grid>
    <Grid item>
      <Typography
        variant="h1"
        sx={{
          padding: '10px 20px',
          color: WHITE
        }}
      >
        Select a location
      </Typography>
    </Grid>
  </Grid>
);

export default LocationListTopMatter;
